module.exports = __webpack_public_path__ + "img/OTPvs15.8bef27fb.png";